<template>
  <div>
    <el-row>
      <el-col :span="24">
        <img class="banner" src="@/assets/images/news_top.jpg" alt=""
      /></el-col>
    </el-row>

    <div class="toptxt">
      <h1>公司动态</h1>
      <img src="@/assets/images/ge.png" alt="" />
    </div>

    <el-row type="flex" justify="center">
      <el-col class="news_img">
        <a href="" @click="handleGo('/information/250320')">
          <img src="@/assets/images/information/2503201.jpg" alt="" /></a
      ></el-col>
      <el-col :xs="23" :sm="10" :md="10" :lg="11">
        <div class="txt">
          <a class="infoone" href="" @click="handleGo('/information/250320')">
            <h2>飞康生物基层检测新利器亮相2025年杭州CACLP展</h2></a>
          <p class="infotwo">
            当基层诊所因设备简陋而延误病情判断，当家庭健康监测只能依赖模糊的定性结果，当传统检测耗时耗力难以普及……苏州飞康生物医药有限公司以硬核科技打破困局，推出全新“胶体金+荧光免疫层析一体机”，将实验室级精准检测压缩至数分钟，让基层医生和家庭用户真正实现“一机在手，健康无忧”。 
          </p>
          <p class="infothree">2025-03-20</p>
        </div>
      </el-col>
      <el-col class="ge" :xs="22" :sm="18" :md="16"> </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col class="news_img">
        <img src="@/assets/images/information/23060101.jpg" alt=""
      /></el-col>
      <el-col :xs="23" :sm="10" :md="10" :lg="11">
        <div class="txt">
          <a class="infoone"><h2>飞康完成居家定量健康自测系统的开发</h2></a>
          <p class="infotwo">
            公司已完成基于手机的居家定量健康自测系统的开发。其中硬件部分已经量产，相关的促黄体生成素（LH）、人绒毛膜促性腺激素（hCG）等试剂正在申请医疗器械注册证。该系统小巧精致、性能优良，特别适合于在院外或家庭受试者招募、伴随诊断、疗效评估、慢病管理等场景下终端消费者的使用。系统将为数字医疗、互联网医疗提供理想的检测工具，与手机一起，进入到千家万户。
          </p>
          <p class="infothree">2023-06-01</p>
        </div>
      </el-col>
      <el-col class="ge" :xs="22" :sm="18" :md="16"> </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col class="news_img">
        <a
          href="https://baijiahao.baidu.com/s?id=1730262792296826561&wfr=spider&for=pc"
          target="_blank"
        >
          <img src="@/assets/images/information/22041601.jpg" alt="" /></a
      ></el-col>
      <el-col :xs="23" :sm="10" :md="10" :lg="11">
        <div class="txt">
          <a
            class="infoone"
            href="https://baijiahao.baidu.com/s?id=1730262792296826561&wfr=spider&for=pc"
            target="_blank"
            ><h2>疫情封控期间飞康员工积极保障所在社区居民的生活</h2></a
          >
          <p class="infotwo">
            公司员工在上海疫情封控期间，积极通过各种形式保障所在社区居民的生活。图为公司员工吕文福担任社区团长和志愿者，保障上海市嘉定区南翔镇某社区居民的购物需求和特殊居民的购药需求（中新经纬2022-04-16）。
          </p>
          <p class="infothree">2022-04-16</p>
        </div>
      </el-col>
      <el-col class="ge" :xs="22" :sm="18" :md="16"> </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col class="news_img">
        <a href="" @click="handleGo('/information/200807')">
          <img src="@/assets/images/information/0807_4.jpg" alt="" /></a
      ></el-col>
      <el-col :xs="23" :sm="10" :md="10" :lg="11">
        <div class="txt">
          <a class="infoone" href="" @click="handleGo('/information/200807')">
            <h2>“一滴血评估女性卵巢功能”参展第十五届郑州美博会</h2></a>
          <p class="infotwo">
            2020中国郑州国际高端美容院线产品及化妆品展览会举办（简称郑州美博会），苏州飞康生物医药有限公司携“一滴血评估女性卵巢功能”产品参展,广受关注。
          </p>
          <p class="infothree">2020-08-07</p>
        </div>
      </el-col>
      <el-col class="ge" :xs="22" :sm="18" :md="16"> </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col class="news_img">
        <a href="" @click="handleGo('/information/200625')">
          <img src="@/assets/images/information/0625_1.jpg" alt="" />
        </a>
      </el-col>
      <el-col :xs="23" :sm="10" :md="10" :lg="11">
        <div class="txt">
          <a class="infoone" href="" @click="handleGo('/information/200625')"
            ><h2>第五届清华校友三创大赛长三角赛区复赛圆满结束!</h2></a
          >
          <p class="infotwo">
            6月20日第五届清华校友创意创新创业大赛长三角赛区复赛在创新之都合肥成功举行，掀起长三角地区创新创业浪潮。“一滴血评估女性卵巢功能”晋级全国总决赛！
          </p>
          <p class="infothree">2020-06-25</p>
        </div>
      </el-col>
      <el-col class="ge" :xs="22" :sm="18" :md="16"> </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col class="news_img">
        <a href="" @click="handleGo('/information/180713')"
          ><img src="@/assets/images/information/0713_1.jpg" alt="" /></a
      ></el-col>
      <el-col :xs="23" :sm="10" :md="10" :lg="11">
        <div class="txt">
          <a class="infoone" href="" @click="handleGo('/information/180713')"
            ><h2>度芽体温贴亮相苏州国际精英创业周喜获青睐</h2></a
          >
          <p class="infotwo">
            苏州飞康生物医药有限公司携代表产品“度芽智能体温贴”分别亮相于苏州“好品秀”新产品新技术发布活动、太仓分会“秀工场”活动。
          </p>
          <p class="infothree">2018-07-13</p>
        </div>
      </el-col>
      <el-col class="ge" :xs="22" :sm="18" :md="16"> </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Information",
  data() {
    return {};
  },
  methods: {
    handleGo(target) {
      this.$router.push(target);
    },
  },
};
</script>

<style lang="less" scoped>
.toptxt {
  margin-top: 30px;
  text-align: center;
}
.ge {
  margin-top: 30px;
  margin-bottom: 10px;
  height: 2px;
  background-color: rgb(206, 206, 206);
}
.el-row {
  flex-wrap: wrap;
}
.txt {
  margin-top: 20px;
  margin-left: 20px;
  justify-content: center;
  .infoone {
    color: #333;
  }
  .infotwo {
    margin: 15px 0;
  }
}
.news_img {
  margin-top: 20px;
  width: 300px;
  height: 200px;
  img {
    width: 300px;
    height: 200px;
  }
}
</style>
